import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html',
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateX({{direction}}%)' }),
                animate('400ms ease-in', style({ transform: 'translateX(0%)' })),
            ], { params: { direction: '-100' } }), // Default direction is -100%
            transition(':leave', [
                animate('400ms ease-in', style({ transform: 'translateX({{direction}}%)' })),
            ], { params: { direction: '-100' } }) // Default direction is -100%
        ])
    ]
})
export class AppSidebarComponent {

    timeout: any = null;

    @ViewChild('menuContainer') menuContainer!: ElementRef;

    @Input() userAD: any | undefined;

    constructor(
        public layoutService: LayoutService,
        public el: ElementRef
    ) { }

    get visible(): boolean {
        return this.layoutService.state.sidebarActive;
    }

    set visible(_val: boolean) {
        this.layoutService.state.sidebarActive = _val;
    }

    onMouseEnter() {
        if (!this.layoutService.state.anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.layoutService.state.sidebarActive = true;
        }
    }

    onMouseLeave() {
        if (!this.layoutService.state.anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => this.layoutService.state.sidebarActive = false, 300);
            }
        }
    }

    anchor() {
        this.layoutService.state.anchored = !this.layoutService.state.anchored;
    }

}
